// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.o-auth {
  overflow-y: auto;
}

.o-auth__content {
  margin-block: auto;
}`, "",{"version":3,"sources":["webpack://./src/app/modules/public/pages/maintenance/maintenance-page.component.scss"],"names":[],"mappings":"AAKA;EACC,gBAAA;AAJD;;AAOA;EACC,kBAAA;AAJD","sourcesContent":["// Keep this short card vertically centered at ANY viewport height. The shared\n// .o-auth organism top-aligns under 800px tall (good for long auth forms) which\n// makes a small card visibly jump on resize. Auto margins centre it regardless\n// of .o-auth's align-items, and still let it scroll if the window is ever\n// shorter than the card. Scoped to this page, so the auth pages are unaffected.\n.o-auth {\n\toverflow-y: auto;\n}\n\n.o-auth__content {\n\tmargin-block: auto;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
